module.exports = __webpack_public_path__ + "img/productIcon1.b84facc8.png";